import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import api, { formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function CloseRequestButton({ request, onChanged, testPrefix = "close", beforeClose }) {
  const [busy, setBusy] = useState(false);
  const close = async () => {
    setBusy(true);
    try {
      if (beforeClose && !(await beforeClose())) return;
      await api.patch(`/requests/${request.id}/status`, { status: "concluido", note: "Encerrado pela gestão" });
      toast.success("Chamado encerrado.");
      onChanged?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button size="sm" variant="outline" disabled={busy}
          className="w-full gap-1.5 border-green-600 text-green-700 hover:bg-green-50"
          data-testid={`${testPrefix}-close-button-${request.id}`}>
          <CheckCircle2 className="h-4 w-4" /> Encerrar chamado
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Encerrar chamado?</AlertDialogTitle>
          <AlertDialogDescription>
            O chamado será marcado como concluído. É obrigatório ter a foto do equipamento (no cadastro do aparelho ou nas fotos da Ordem de Serviço).
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Voltar</AlertDialogCancel>
          <AlertDialogAction className="bg-green-600 hover:bg-green-700" onClick={close}
            data-testid={`${testPrefix}-close-yes-${request.id}`}>Sim, encerrar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
